import { render, staticRenderFns } from "./NumberDetails.vue?vue&type=template&id=2ca6b638&scoped=true&"
import script from "./NumberDetails.vue?vue&type=script&lang=js&"
export * from "./NumberDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6b638",
  null
  
)

export default component.exports